<template>
  <v-col>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="localtranslation.name"
          :rules="rules.requiredTextLine65"
          :counter="65"
          :label="`${$t('APP_CONTENT.NAME_IN_THE_APP')}` + requiredStr"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text--secondary text-caption">
          {{ $t('ITEM.DESCRIPTION') }}
        </div>
        <v-card outlined>
          <ckeditor
            v-model="localtranslation.description"
            :editor="editor"
            :config="editorConfig"
            :style="[minHeight]"
            @ready="onReady"
          >
          </ckeditor>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import { cloneDeep } from 'lodash';
import { requiredTextLine65 } from '@/modules/_global/variables/rules.js';
import DecoupledDoc from '@ckeditor/ckeditor5-build-decoupled-document';
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/de';
const upload = require('@/modules/app_content/components/ckeditor/assets/upload.js');

export default {
  name: 'AppContentHtmlForm',

  components: {},

  model: {
    prop: 'translation'
  },

  props: {
    translation: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    editor: DecoupledDoc,
    editorData: '<h1>data</h1>',
    editorConfig: {
      // language: 'de',
      extraPlugins: [upload.MyCustomUploadAdapterPlugin]
    },
    requiredStr: '',
    minHeight: {
      height: '300px',
      minHeight: '300px'
    },

    valid: true,
    localtranslation: {},
    rules: {
      requiredTextLine65
    }
  }),
  watch: {
    localtranslation: {
      deep: true,
      handler: 'setTranslation'
    },
    translation: {
      deep: true,
      handler() {
        if (
          JSON.stringify(this.translation) ===
          JSON.stringify(this.localtranslation)
        ) {
          return;
        }
        this.setData();
      }
    }
  },
  created() {
    this.setData();
    this.setRequired();
  },

  methods: {
    onReady(editor) {
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },

    setData() {
      this.localtranslation = cloneDeep(this.translation);
    },
    setTranslation() {
      this.$emit('input', Object.assign({}, this.localtranslation));
    },

    setRequired() {
      this.requiredStr = ' *';
    }
  }
};
</script>
<style>
.ck-editor__editable {
  /*min-height: 400px;*/
  /*border: 1px solid #ccc!important;*/
}
</style>
